/**
 * FrostDismissalBanner.jsx
 * ────────────────────────
 * Compact dismissible banner for frost law advisory.
 * Appears as a card above the tool list — not full-screen.
 */

import React from 'react';
import './FrostDismissalBanner.css';

export default function FrostDismissalBanner({ isVisible, stateName, onDismiss }) {
  if (!isVisible) return null;

  return (
    <div className="frost-banner">
      <div className="frost-icon">&#9888;</div>
      <div className="frost-body">
        <div className="frost-title">Frost Law Advisory</div>
        <div className="frost-text">
          Frost law weight restrictions are currently active in <strong>{stateName}</strong>.
          Confirm load weights comply before shipping.
        </div>
      </div>
      <button className="frost-dismiss" onClick={onDismiss}>
        Got it
      </button>
    </div>
  );
}
